import { IPolicyElement } from './IPolicyElement';

export class PolicyElement implements IPolicyElement {
  constructor(
    public key: string,
    public value: boolean = false,
  ) {}

  apply(key: string): boolean {
    if (key === this.key) {
      this.value = true;
      return true;
    }
    return false;
  }

  reset(): void {
    this.value = false;
  }
}
